<script>
import OrdersApi from "@/services/orders-api";
import {Priviliges} from "../privileges";

export default {

    props: {
        showDrafts:{
          type: Boolean,
          default: false,
        },
        supplierId: Number,
        customerId: Number,
        status:Number,
        isHomePage:{
          type:Boolean,
          default:false
        },
        isCurrent:{
          type:Boolean,
          default:false
        },
        isMinimumOrders:{
          type:Boolean,
          default:false
        },
        start:{
          type:String,
          default:null
        },
        end:{
          type:String,
          default:null
        },
        showUnsynchronisedOrders:{
          type: Boolean,
          default: false,
        },

    },

    
    data () {
        return {
        singleSupplierFields: [
        
        { key:"submissionDate", label: "Date",   sortable: false, tdClass:"font-weight-bold align-middle",},
        { key:"extId", label: "Nº BC",thClass:"",tdClass:" align-middle" },
        { key:"submissionUserName", label: "Vendeur",   thClass:"", tdClass:" align-middle"},
        { key:"itemsCount", label: "Articles",   thClass:"text-right d-md-table-cell d-none", tdClass:"font-size-14 text-right d-md-table-cell d-none align-middle"},
        { key:"total", label: "Total HT",   thClass:"text-right d-md-table-cell ", tdClass:"text-right font-size-14 d-md-table-cell align-middle",},
        { key:"totalTtc", label: "Total TTC",   thClass:"text-right d-md-table-cell ", tdClass:"text-right font-size-14 d-md-table-cell align-middle",},

        { key:"isPartial", label: "isPartial",  thClass:"text-right ", tdClass:"align-middle text-right"},
        { key:"status", label: "Etat de livraison",   thClass:"text-right ", tdClass:"text-right align-middle"},
        // { key:"deliveryStatus", label: "Etat de livraison",   thClass:"text-right ", tdClass:"text-right align-middle"},
        // { key:"billingStatus", label: "Etat de de crédit",  thClass:"text-right d-md-table-cell d-none", tdClass:"text-right d-md-table-cell d-none align-middle"},
        // { key:"export", label:"",tdClass:"text-right"},

        { key:"message", label: "",  thClass:"text-right ", tdClass:"align-middle text-right"},
        { key:"actions", label:"",tdClass:"text-center"},
        ],

        forSupplierFields: [
        
        { key:"submissionDate", label: "Date", sortable: false, tdClass:"font-weight-bold align-middle"},
        { key:"extId", label: "Nº BC",thClass:"",tdClass:" align-middle" },
        { key:"ref", label: "Ref",thClass:"",tdClass:" align-middle" },
        { key:"submissionUserName", label: "Vendeur",   thClass:" ", tdClass:" align-middle"},
        { key:"customerName", label: "Client", tdClass:"font-weight-bold align-middle"},
        { key:"itemsCount", label: "Articles",   thClass:"text-right d-md-table-cell d-none", tdClass:"font-size-14 text-right d-md-table-cell d-none align-middle"},
        { key:"total", label: "Total HT",   thClass:"text-right d-md-table-cell", tdClass:"text-right font-size-14 d-md-table-cell align-middle",},
        { key:"totalTtc", label: "Total TTC",   thClass:"text-right d-md-table-cell ", tdClass:"text-right font-size-14 d-md-table-cell align-middle",},

        { key:"isPartial", label: "isPartial",  thClass:"text-right ", tdClass:"align-middle text-right"},
        { key:"status", label: "Etat de livraison",  thClass:"text-right ", tdClass:"text-right  align-middle"},
        // { key:"deliveryStatus", label: "Etat de livraison",   thClass:"text-right ", tdClass:"text-right align-middle"},
        // { key:"billingStatus", label: "Etat de de crédit",  thClass:"text-right d-md-table-cell d-none", tdClass:"text-right d-md-table-cell d-none align-middle"},
        { key:"restartSync", label:"",tdClass:"text-right"},
        // { key:"export", label:"",tdClass:"text-right"},
        
        { key:"message", label: "",  thClass:"text-right ", tdClass:"align-middle text-right"},
        { key:"actions", label:"",tdClass:"text-center"},
        ],

        minimumFields: [
            { key:"submissionDate", label: "Date d'ajout", tdClass:"font-weight-bold"},
            { key:"totalWithTaxes", label:"Total TTC",thClass:"text-left" ,tdClass: "text-left"},
            { key:"status", label: "Etat de livraison",thClass:"text-left" ,tdClass:"text-left"},
            // { key:"deliveryStatus", label: "Etat de livraison",   thClass:"text-right ", tdClass:"text-right align-middle"},
            ],
        ordersListFieldsHomePageForCustomer: [
            { key:"submissionDate", label: "Date d'ajout", tdClass:"font-weight-bold"},
            { key:"extId", label: "Nº BC",thClass:"",tdClass:"" },
            { key:"submissionUserName", label: "Vendeur",   thClass:" ", tdClass:" align-middle"},
            { key:"total", label:"Total HT",thClass:"text-right d-md-table-cell d-none" , tdClass: "text-right d-md-table-cell d-none"},
            { key:"isPartial", label: "isPartial",  thClass:"text-right ", tdClass:"align-middle text-right"},
            { key:"status", label: "Etat de livraison",thClass:"text-right" ,tdClass:"text-right align-middle"},
            // { key:"deliveryStatus", label: "Etat de livraison",   thClass:"text-right ", tdClass:"text-right align-middle"},
            // { key:"billingStatus", label: "Etat de crédit",thClass:"text-right d-md-table-cell d-none" ,tdClass:"text-right align-middle d-md-table-cell d-none"},
            ],
        ordersListFieldsHomePageForSupplier: [
            { key:"submissionDate", label: "Date d'ajout", tdClass:"font-weight-bold"},
            { key:"extId", label: "Nº BC",thClass:"",tdClass:"" },
            { key:"ref", label: "Ref",thClass:"",tdClass:" align-middle" },
            { key:"customerName", label: "Client", tdClass:"font-weight-bold align-middle"},
            { key:"submissionUserName", label: "Vendeur",   thClass:" ", tdClass:"align-middle"},
            { key:"total", label:"Total HT",thClass:"text-right d-md-table-cell d-none" , tdClass: "text-right d-md-table-cell d-none"},
            { key:"isPartial", label: "isPartial",  thClass:"text-right ", tdClass:"align-middle text-right"},
            { key:"status", label: "Etat de livraison",thClass:"text-right" ,tdClass:"text-right align-middle"},
            
            // { key:"deliveryStatus", label: "Etat de livraison",   thClass:"text-right ", tdClass:"text-right align-middle"},
            // { key:"billingStatus", label: "Etat de crédit",thClass:"text-right d-md-table-cell d-none" ,tdClass:"text-right align-middle d-md-table-cell d-none"},
            ],

        pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},

        ordersList: [],
        isTableLoading: false,
        role:null,
        privileges:"",
        isAdmin:false,
        exportOrdersInProgress : false,
        restartingSyncInProgress:false,

        }

    },
    mounted () {
      this.role=sessionStorage.getItem("userr");
      if(sessionStorage.getItem("privileges")!=null){
          this.privileges=sessionStorage.getItem("privileges")
          this.isAdmin=this.privileges.includes(Priviliges[0]["Admin_Role"] )
        }
      this.getOrders();
  },

methods: {
   statusToLabel(status) {
      switch(status) {
        case 0: return 'draft';
        case 1: return 'new';
        case 2: return 'confirmed';
        case 3: return 'delivered';
        case 4: return 'canceled';
        default: return '_';
      }
    },

    deliveryStatusToLabel(deliveryStatus,status){
      if(status!=2 && status!=3){
        return '_'
      }
      switch(deliveryStatus){
        case 0 : return 'notDelivered';
        case 1 : return 'partiallyDelivered';
        case 2 : return 'delivered';
        default: return 'notDelivered'
      }
    },

    deliveryStatusToColor(deliveryStatus,status){
      if(status!=2 && status!=3){
        return 'black'
      }
      switch(deliveryStatus){
        case 0 : return 'danger';
        case 1 : return 'info';
        case 2 : return 'success';
        default: return 'danger'
      }
    },

    statusToColor(status) {
      switch(status) {
        case 0: return 'secondary';
        case 1: return 'danger';
        case 2: return 'info';
        case 3: return 'success';
        case 4: return 'secondary';
        default: return 'black';
      }
    },

    outstandingStatusToLabel(status){
      switch(status) {
        case 0: return 'OK';
        case 1: return 'Bloqué';
        case 2: return 'Dépas. en-cours';
        case 3: return 'Acpte non versé';
        case 4: return 'Sage Exchange';
        default: return '';
      }
    },

    billingStatusToLabel(status,orderStatus){
      if(orderStatus!=2 && orderStatus!=3){
        return '_'
      }
      switch(status){
        case 0: return 'notBilled';
        case 1:return 'partiallyBilled';
        case 2 :return 'billed';
        default: return '_'
      }
    },

    billingStatusToColor(status,orderStatus){
      if(orderStatus!=2 && orderStatus!=3){
        return '_'
      }
      switch(status){
        case 0: return 'danger';
        case 1:return 'warning';
        case 2 :return 'success';
        default: return '_'
      }
    },

    getOrders() {
      this.isTableLoading = true

      if (this.role==1) {
         OrdersApi.getOrders(this.pagemodel.currentPage, this.pagemodel.perPage, this.showDrafts,this.status,this.customerId,this.start,this.end,this.isCurrent,this.showUnsynchronisedOrders)
      .then(orders => {
        if(orders){
          this.ordersList = orders.list
          this.pagemodel.totalRows = orders.total;
          this.pagemodel.currentPage = orders.page;
          this.pagemodel.perPage = orders.pageSize;
          this.pagemodel.pageSize = orders.pageSize;
        }

      })
      .finally(() => {
        this.isTableLoading=false 
      })
      }

      if(this.role==0){

      OrdersApi.getOrdersByCustomer(this.pagemodel.currentPage, this.pagemodel.perPage,this.supplierId, false,this.status,this.isCurrent,this.start,this.end)
      .then(orders => {
        if(orders){
          this.ordersList = orders.list
          this.pagemodel.totalRows = orders.total;
          this.pagemodel.currentPage = orders.page;
          this.pagemodel.perPage = orders.pageSize;
          this.pagemodel.pageSize = orders.pageSize;

        }

      })

      .finally(() => {
        this.isTableLoading=false 
      })

      }
    },

    exportEXCEL(orderId){
        this.exportOrdersInProgress = true;
      OrdersApi.exportOrder(orderId)
       .then(() => {
           this.exportOrdersInProgress = false;
        })
    },

    exportOrdersListExcel: function(showDetails) {
        return OrdersApi.export(this.pagemodel.currentPage, this.pagemodel.perPage, this.showDrafts,this.status,this.customerId,this.start,this.end,showDetails,this.showUnsynchronisedOrders)
    },

    restartSync(orderId){
      this.restartingSyncInProgress=true
      OrdersApi.restartSync(orderId).then(
        (result)=>{
          if(result){
            this.getOrders()
          }
          this.restartingSyncInProgress=false
        }
      )
    }

},

  watch: {
    supplierId : function(){
      this.getOrders()
    },

    customerId: function(){
      this.getOrders()
    },

    status: function(){
      this.getOrders()
    },

    showDrafts: function(){
      this.getOrders()
    },

    showUnsynchronisedOrders: function(){
      this.getOrders()
    },
    
    end: function(){
      if((this.end  && this.start) || (!this.end  && !this.start) ){
        this.getOrders()
      }
      
    },
    start: function(){
      if((this.end && this.start) || (!this.end  && !this.start)  ){
        this.getOrders()

      }
    },


},
  };


</script>


<template>
<div>
    <div class="table-responsive mt-3" :style="[isHomePage ? {'min-height': '45em', 'max-height' : '45em'} : {}]">        
        <b-table 
        :busy="isTableLoading"
        :striped="true"

        :small="false"
        :hover="true"

        :items="ordersList"
        :fields="isHomePage ? (role==1 ? ordersListFieldsHomePageForSupplier : ordersListFieldsHomePageForCustomer) : (isMinimumOrders ? minimumFields : (role==1 ? forSupplierFields : singleSupplierFields))"

        :perPage="pagemodel.perPage"
        class="table  "
        >
        <template v-slot:table-busy>
        <div class="text-center my-2">
            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
        </template>

      <template v-slot:head(submissionDate)>
        {{ $t("ordersMenu.list.header.submissionDate") }} 
      </template>

      <template v-slot:head(ref)>
        {{ $t("ordersMenu.list.header.ref") }} 
      </template>

      <template v-slot:head(itemsCount)>
        {{ $t("ordersMenu.list.header.itemsCount") }} 
      </template>

      <template v-slot:head(total)>
        {{ $t("ordersMenu.list.header.total") }} 
      </template>

      <template v-slot:head(totalWithTaxes)>
        {{ $t("ordersMenu.list.header.totalWithTaxes") }} 
      </template>

      <template v-slot:head(customerName)>
        {{ $t("ordersMenu.list.header.customerName") }} 
      </template>

      <template v-slot:head(isPartial)>
        Liv Partielle
      </template>

      <template v-slot:head(status)>
        {{ $t("ordersMenu.list.header.orderStatus") }} 
      </template>

      <template v-slot:head(submissionUserName)>
        Vendeur
      </template>

      <!-- <template v-slot:head(deliveryStatus)>
        {{ $t("ordersMenu.list.header.status") }} 
      </template>

      <template v-slot:head(billingStatus)>
        {{ $t("ordersMenu.list.header.credit") }} 
      </template> -->

      <template v-slot:head(sageRef)>
        {{ $t("ordersMenu.list.header.sageRef") }} 
      </template>

      <template v-slot:cell(actions)="{item}"> 
        <router-link :to="{ path: '/orders/order', query: { orderId: item.id }}">
          <b-button v-if="item.linesCount" title="Ouvrir"  size="sm"   variant="outline-primary" >
                <i class="fas fa-file-import font-size-16 align-middle mr-0 mr-sm-2"></i>
                <span class="d-none font-weight-bold d-sm-inline">{{ $t("ordersMenu.list.button")}}</span>
          </b-button> 
        </router-link>

      </template>

      <!-- <template v-slot:cell(export)="{item}">
          <b-button title="Exporter"  size="sm"   variant="outline-info"  @click.prevent="exportEXCEL(item.id)" :disabled="exportOrdersInProgress"  >
            <b-spinner small :class="exportOrdersInProgress ? 'mr-1' : 'd-none'"></b-spinner>
            <i class="fas fa-file-excel  font-size-16  font-weight-bold align-middle mr-0 mr-sm-2"></i>
            <span class=" font-weight-bold text-uppercase d-none d-sm-inline">{{ $t("ordersMenu.list.export")}} </span>         
          </b-button> 
      </template> -->

      <template v-slot:cell(restartSync)="{item}">
          <b-button v-if="isAdmin && item.extId == null && item.status != 0"  title="Sync" size="sm"   variant="outline-danger"  @click.prevent="restartSync(item.id)" :disabled="restartingSyncInProgress"  >
            <b-spinner small :class="restartingSyncInProgress ? 'mr-1' : 'd-none'"></b-spinner>
            <i class="fas fa-sync-alt  font-size-16  font-weight-bold align-middle  mr-0 mr-sm-2"></i>
            <span class=" font-weight-bold text-uppercase d-none d-sm-inline">{{ $t("ordersMenu.list.restartSync")}}</span>         
          </b-button> 
      </template>

      <template v-slot:cell(isPartial)="{value}">
        <i v-if="value" title="Livraison Partielle" style="color:#ffcc00" class="fas fa-exclamation-circle font-size-20  font-weight-bold align-middle"></i>
      </template>

      <template v-slot:cell(message)="{item, value}">
        <i v-if="item.isDeliveryModeChanged" title="Le client a modifié le mode de livraison" class="far fa-dolly-flatbed text-warning font-size-16 mr-2 font-weight-bold align-middle"></i>
        <i v-if="item.message" :title="item.message" style="color:#ffcc00" class="far fa-comment-dots font-size-20 ml-2 font-weight-bold align-middle"></i>
      </template>

      <template v-slot:cell(status)="{item,value}">
        <h5><b-badge href="#" :variant="statusToColor(value)">{{item.extStatusStr != null ? item.extStatusStr : $t("ordersMenu.statusLabel."+statusToLabel(item.status))}}</b-badge></h5>
      </template>

      <template v-slot:cell(submissionUserName)="{value}">
        {{value ? value : ''}}
      </template>

      <!-- <template v-slot:cell(deliveryStatus)="{item,value}">
        <h5><b-badge href="#" :variant="deliveryStatusToColor(value,item.status)">{{$t("ordersMenu.statusLabel."+deliveryStatusToLabel(value,item.status))}}</b-badge></h5>
      </template>

      <template v-slot:cell(billingStatus)="{item,value}">
        <h5><b-badge href="#" :variant="billingStatusToColor(value,item.status)">{{$t("ordersMenu.billingStatus."+billingStatusToLabel(value,item.status))}}</b-badge></h5>
      </template> -->

        <template v-slot:cell(ref)="{item,value}">
        <span :class="item.status ==0 ? 'text-danger' : ''">{{value}}</span>
        </template>

        <template v-slot:cell(submissionDate)="{item,value}">
          <span v-if="item.status == 0" class="text-danger"><i class="mdi mdi-clock-outline mr-2"></i>{{ $t("ordersMenu.list.draft")}} ({{ item.date }})</span>
          <span v-if="item.submissionDate">{{value}}</span>
        </template>

        <template v-slot:cell(sageRef)="{item}">
            {{item.sageRef}}
        </template>

        </b-table>
        <span v-if="!isTableLoading && ordersList && !ordersList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('ordersMenu.list.empty')}} </span>
    </div>

    <!-- Pagination -->
    <div class="row pt-3 mb-sm-0">
        <div class="col-sm-8">
            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                <b-form-select @input="getOrders()"  v-model="pagemodel.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{$t('pagination.from')}}</span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{$t('pagination.lines')}}</span></div>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getOrders()" :disabled="isTableLoading" ></b-pagination>
                </ul>
            </div>
        </div>
    </div> 
    <!-- Fin Pagination  -->
</div>
</template>                 
               